import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import { IParameterGroup, TCreateGroupParameterDTO } from '@/pages/Parameters/parameters.types.ts'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import parametersApi from '@/pages/Parameters/parameters.api.ts'
import parameterGroupsEvents from '@/pages/Parameters/events/groups/paramterGroups.events.ts'
import ParameterGroupDropdown from '@/pages/Parameters/components/ParameterGroupDropdown'
import { useEffect } from 'react'
import SeparateLine from '@/shared/Forms/SeparateLine'

interface IProps {
  initialParentId?: IParameterGroup['id']
  open: boolean
  onClose: () => void
}

const CreateParameterGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [group, setGroup, handleChange] = useStateWithChange<TCreateGroupParameterDTO>({
    name: '',
    parentId: props.initialParentId ?? 0,
  })

  useEffect(() => {
    setGroup({
      name: '',
      parentId: props.initialParentId ?? 0,
    })
  }, [props.initialParentId])

  const handleSave = () => {
    wait(parametersApi.createGroup(group), (resp) => {
      if (resp.status === 'success') {
        parameterGroupsEvents.created(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Создание группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <ParameterGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={group.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={group.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default CreateParameterGroupModal
